import { parseCurrency } from '@helper/parseCurrency'

import { displayDateBrazilian } from '../../util/standardizedDate'

const formattedDate = (date: string) => {
  return displayDateBrazilian(date)
}

const formattedValue = (value: number) => {
  return value.toFixed(2).replace('.', ',')
}

export const parseRuptureKpiData = (data: any[]): any[] => {
  return data?.length === 0
    ? []
    : data.map(item => {
        return {
          'data-execucao-id': item.periodo ? formattedDate(item.periodo) : 0,

          'cd-loja-codigo-id': item.lojaId ? item.lojaId : 0,
          'cd-loja-nome-id': item.lojaDescricao ? item.lojaDescricao : '',

          'gerente-categoria-id': item.gerenteCategoriaDescricao
            ? item.gerenteCategoriaDescricao
            : '',
          'gerente-produto-id': item.gerenteProdutoDescricao
            ? item.gerenteProdutoDescricao
            : '',

          'mundo-codigo-id': item.mundoId ? item.mundoId : 0,
          'mundo-nome-id': item.mundoDescricao ? item.mundoDescricao : '',

          'categoria-compacta-codigo-id': item.categoriaCompactaId
            ? item.categoriaCompactaId
            : 0,
          'categoria-compacta-nome-id': item.categoriaCompactaDescricao
            ? item.categoriaCompactaDescricao
            : '',

          'categoria-codigo-id': item.categoriaId ? item.categoriaId : 0,
          'categoria-nome-id': item.categoriaDescricao
            ? item.categoriaDescricao
            : '',

          'status-nome-id': item.statusDescricao ? item.statusDescricao : '',

          'curva-abc-nome-id': item.curvaABCDescricao
            ? item.curvaABCDescricao
            : '',

          'empresa-codigo-id': item.empresaId ? item.empresaId : 0,
          'empresa-nome-id': item.empresaDescricao ? item.empresaDescricao : '',

          'fornecedor-codigo-id': item.fornecedorId ? item.fornecedorId : 0,
          'fornecedor-nome-id': item.fornecedorDescricao
            ? item.fornecedorDescricao
            : '',

          'ruptura-one-day-id': item.rupturaPercentualZeroDias
            ? formattedValue(item.rupturaPercentualZeroDias)
            : 0,
          'ruptura-ten-days-id': item.rupturaPercentualDezDias
            ? formattedValue(item.rupturaPercentualDezDias)
            : 0,
          'ruptura-one-total-id': item.totalSKUs
            ? parseCurrency({
                value: item.totalSKUs,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-ten-total-id': item.totalSKUs
            ? parseCurrency({
                value: item.totalSKUs,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-one-sku-id': item.skUsRupturaZeroDias
            ? parseCurrency({
                value: item.skUsRupturaZeroDias,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-ten-sku-id': item.skUsRupturaDezDias
            ? parseCurrency({
                value: item.skUsRupturaDezDias,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-ten-day-venda-media': item.vendaMediaTotalSkus
            ? parseCurrency({
                value: item.vendaMediaTotalSkus,
                country: 'pt-br',
                minFraction: 1,
                maxFraction: 1
              })
            : 0,
          'ruptura-ten-day-venda-perdida': item.vendaPerdidaRupturaDezDias
            ? parseCurrency({
                value: item.vendaPerdidaRupturaDezDias,
                country: 'pt-br',
                minFraction: 1,
                maxFraction: 1
              })
            : 0,
          'ruptura-ten-day-ruptura-real': item.rupturaReaisDezDias
            ? formattedValue(item.rupturaReaisDezDias)
            : 0,
          'ruptura-one-day-venda-media': item.vendaMediaTotalSkus
            ? parseCurrency({
                value: item.vendaMediaTotalSkus,
                country: 'pt-br',
                minFraction: 1,
                maxFraction: 1
              })
            : 0,
          'ruptura-one-day-venda-perdida': item.vendaPerdidaRupturaZeroDias
            ? parseCurrency({
                value: item.vendaPerdidaRupturaZeroDias,
                country: 'pt-br',
                minFraction: 1,
                maxFraction: 1
              })
            : 0,
          'ruptura-one-day-ruptura-real': item.rupturaReaisZeroDias
            ? formattedValue(item.rupturaReaisZeroDias)
            : 0,
          'cd-loja-tipo-id': item.centroDistribuicaoDescricao
            ? item.centroDistribuicaoDescricao
            : '',
          'subcategoria-codigo-id': item.subCategoriaId
            ? item.subCategoriaId
            : 0,
          'subcategoria-nome-id': item.subCategoriaDescricao
            ? item.subCategoriaDescricao
            : ''
        }
      })
}
